import styled from 'styled-components';
import { Card, Tabs as AntTabs } from 'antd';
import { COLORS } from '../../../constants/colors';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export const WarningMessage = styled.div`
  background-color: #fff7e6;
  border: 1px solid #ffe58f;
  border-radius: 8px;
  padding: 17px;
  margin-bottom: 20px;
`;

export const StatsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  height: 100px;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
`;

export const ArrowButton = styled.button`
  position: absolute;
  background: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  cursor: pointer;
  z-index: 1;

  &:hover {
    background: #f0f0f0;
  }

  &:focus {
    outline: none;
  }
`;

export const LeftArrow = styled(ArrowButton)`
  position: absolute;
  left: 10px;
  top: 40%;
  transform: translateY(-50%);
  z-index: 2;
`;

export const RightArrow = styled(ArrowButton)`
  position: absolute;
  right: 10px;
  top: 40%;
  transform: translateY(-50%);
  z-index: 2;
`;

export const Stat = styled.div`
  flex: 1;
  text-align: center;
`;

export const Divider = styled.div`
  width: 1px;
  height: 60%;
  background-color: #ccc;
  margin: 0 20px;
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 40px;
`;

export const ShopToggle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

export const ScrollableContainer = styled.div`
display: flex;
max-width: 350px;
overflow-x: auto;
white-space: nowrap;
padding: 10px 0;

&::-webkit-scrollbar {
  display: none; /* Hide scrollbar */
}
`;

export const ScrollableShopContainer = styled.div`
  display: flex;
  overflow-x: scroll;
  gap: 16px;
  margin-bottom: 10px;
  scroll-snap-type: x mandatory;
  padding-top: 10px;
  padding-bottom: 10px;

&::-webkit-scrollbar {
  display: none; /* Hide scrollbar */
}
`;

export const SocialIconsWrapper = styled.div`
position: relative;
max-width: 100%;
overflow: hidden;
`;

export const ScrollButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.7);
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1;

  &:hover {
    background: rgba(255, 255, 255, 0.9);
  }

  &.left {
    left: 0;
  }

  &.right {
    right: 0;
  }
`;


export const ScrollableItem = styled.div`
  scroll-snap-align: start;
  flex: 0 0 auto;
  width: 230px; /* Adjust width as needed */
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const StyledTabs = styled(AntTabs)`
  .ant-tabs-nav::before {
    border-bottom: none;
  }

  .ant-tabs-tab {
    color: ${props => props.theme?.card_text_color || '#000000'};
    font-weight: bold;
  }

  .ant-tabs-tab-active {
    .ant-tabs-tab-btn {
      color: ${props => props.theme?.activeTabTextColor || props.theme?.card_text_color || '#000000'} !important;
    }
  }

  .ant-tabs-ink-bar {
    background-color: ${props => props.theme?.activeTabTextColor || props.theme?.card_text_color || '#000000'};
  }
`;

export const TabContent = styled.div`
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  opacity: ${props => (props.active ? 1 : 0)};
  transform: translateY(${props => (props.active ? '0' : '20px')});
  width: 100%;
`;

export const TabsWrapper = styled.div`
    min-height: auto;
`;

export const TabsContainer = styled.div`
  margin: 20px 0;

  .ant-tabs-nav::before {
    border-bottom: none;
  }
  
  .ant-tabs-nav {
    margin-bottom: 30px
  }
  
  .ant-tabs-nav-list {
    justify-content: center;
    width: 100%;
  }
  .ant-tabs-tab {
    font-size: 16px;
    padding: 10px 27px;
  }
`;

export const ContentContainer = styled.div`
  padding: 0px;
  background-color: ${(props) => props.theme?.background_color || '#f5f5f5'};
  flex: 1; // Allow it to grow and fill the available space
  display: flex;
  flex-direction: column;
`;

export const ProductCard = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: 20px;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
  background-color: ${(props) => props.theme?.card_color || '#1c1c1c'};
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;

  .product-content {
    display: flex;
    width: 100%;
    align-items: flex-start;
    margin-bottom: 15px;
  }

  .product-info {
    flex-grow: 1;
    padding-left: 20px;
    text-align: left;
  }

  .product-image {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 100px;
    border-radius: 10px;
  }

  h3 {
    margin: 0;
    font-size: 18px;
    color: white;
  }

  p {
    margin: 5px 0;
    color: #d3d3d3;
  }

  .product-price {
    font-size: 16px;
    color: ${({ theme }) => theme?.card_text_color || '#000'};

    .amount {
      font-weight: bold;
    }
  }

  .product-button {
    margin-top: auto;
    width: 100%;
    background-color: ${COLORS.$mainBlue};
    color: ${({ theme }) => theme?.button_text_color || '#FFFFFF'};
    font-weight: bold;
    min-height: 55px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    text-decoration: none;
    border-radius: 15px;

    &:hover {
      background-color: ${COLORS.$mainBlueHover};
      color: white;
    }
  }

  .button-text {
    flex-grow: 1;
    text-align: left;
  }

  .button-icon {
    margin-left: 10px;
    display: flex;
    align-items: center;
  }

  .ant-card-body {
    padding: 0px;
    width: 100%;
    border-radius: 15px;
  }

  &.card-fill-slightly-rounded {
    border-radius: 10px;
    background-color: ${({ theme }) => theme?.card_color || '#2E2E2E'};
  }

  &.card-default {
    border-radius: 5px;
    background-color: ${({ theme }) => theme?.card_color || '#f3f3f1'};
  }
`;

export const SimpleProductCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
  background-color: ${({ theme }) => theme?.card_color || '#f3f3f1'};
  border-radius: 17px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.2s;
  height: 75px;

  &:hover {
    transform: scale(1.02);
  }

  .block__card--pill {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 10px;
    background-color: ${({ theme }) => theme?.card_color || '#f0f0f0'};
    border: none;
    border-radius: 17px;
    text-decoration: none;
    color: inherit;

    &:hover {
      background-color: ${({ theme }) => theme?.card_color ? `${theme.card_color}dd` : '#e0e0e0'};
    }
  }

  .block__image--pill {
    margin-right: 15px;

    .base-preview-image {
      width: 55px;
      height: 55px;
      border-radius: 10px;
      object-fit: cover;
    }
  }

  .block__content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .block__content.centered {
    align-items: center;
    width: 100%;
    text-align: center;
  }

  .block__text--pill {
    font-size: 18px;
    color: ${({ theme }) => theme?.card_text_color || 'black'};
    font-weight: bold;
  }

  .price-review {
    display: flex;
    align-items: center;
    margin-top: 5px;

    .product-price {
      font-size: 16px;
      color: ${({ theme }) => theme?.card_text_color || '#000'};

      .amount {
        font-weight: bold;
      }
    }
  }

  &.card-fill-slightly-rounded {
    border-radius: 10px;
    background-color: ${({ theme }) => theme?.card_color || '#2E2E2E'};
  }

  &.card-default {
    border-radius: 5px;
    background-color: ${({ theme }) => theme?.card_color || '#f3f3f1'};
  }
`;

export const CustomCloseButton = styled.button`
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  border: 1px solid lightgray;
  border-radius: 50%;
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
`;

export const CustomModalContent = styled.div`
.ant-modal-content {
  padding: 5px 5px !important;
}

  .ant-modal {
    max-width: 480px !important;
    max-height: 1024px !important;
  }

  .ant-modal-content {
    border-radius: 25px !important;
    background-color: ${({ theme }) => theme?.background_color || 'black'};
    padding: 5px 5px !important;
  }

  .ant-modal-body {
    padding: 5px !important;
    background-color: ${({ theme }) => theme?.background_color || 'black'};
  }

  .ant-modal-wrap {
    background-color: ${({ theme }) => theme?.background_color || 'black'};
  }
`;

export const SectionTitle = styled.div`
  text-align: center;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 20px;
  color: ${({ theme }) => theme?.card_text_color || 'black'};
`;

export const SocialIconsContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 15px;
`;

export const SocialIconLink = styled.a`
  color: ${props => props.theme?.font_color || '#000000'};
  font-size: 24px;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 0.7;
  }
`;

export const SocialButtons = styled.div`
  display: flex;
  gap: 10px;

  a {
    text-decoration: none;
  }

  .ant-btn {
    ${({ theme }) => {
    const isGhost = theme?.card_style?.includes('outline');
    return `
        background-color: ${isGhost ? 'transparent' : theme?.button_color || 'rgba(255, 255, 255, 0.9)'} !important;
        border: ${isGhost ? `2px solid ${theme?.button_color || 'rgba(255, 255, 255, 0.9)'}` : 'none'} !important;
        
        &:hover {
          background-color: ${isGhost
        ? `${theme?.button_color || 'rgba(255, 255, 255, 0.9)'}33`
        : theme?.button_color
          ? `${theme.button_color}dd`
          : 'rgba(255, 255, 255, 0.7)'
      } !important;
        }

        .anticon {
          color: ${isGhost ? theme?.button_color : theme?.button_text_color || '#000000'} !important;
          position: relative;
          top: ${isGhost ? '0px' : '1px' || '0px'} !important;
          left: ${isGhost ? '0.5px' : '0px' || '0px'} !important;
        }
      `;
  }}
  }
`;

// Existing Styled Components from UserStore Page

export const StyledWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100vh;
    background-color: #000000;
    padding: 20px;
    overflow-y: auto;
`;

export const ProductCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 600px;
    background-color: #1e1e1e;
    margin-bottom: 20px;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

    .product-content {
        display: flex;
        width: 100%;
        align-items: center;
    }

    .product-image {
        margin-right: 20px;
    }

    .product-info {
        flex: 1;
        color: #fff;

        h3 {
            color: #fff;
            margin-bottom: 5px;
        }

        p {
            color: #ccc;
        }
    }

    .product-button {
        margin-top: 10px;
    }
`;

export const SectionTitleWrapper = styled.h3`
    color: ${({ theme }) => theme?.card_text_color || '#fff'};
    margin-bottom: 27px;
    margin-top: 27px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    text-align: center;
`;

export const ContentWrapper = styled.div`
  max-width: 750px;
  padding-bottom: 150px!important;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
`;

export const FooterBannerButton = styled.a`
    background-color: #f8f9fa;
    padding: 10px; 
    width: 90%; 
    height: 45px; 
    display: flex;
    margin: auto;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
    text-decoration: none;
    color: black;
    font-weight: bold;
    border-radius: 50px;
    text-align: center;
    cursor: pointer;

    &:hover {
        background-color: #ebf4ff;
    }
`;

export const FooterLogo = styled.img`
    height: 22px;
    margin-left: 10px;
    margin-top: 5px;
`;

export const VerifiedBadgeContainer = styled.div`
  position: absolute;
  width: 24px;
  height: 24px;
  ${({ imageStyle }) => imageStyle === 'Hero'
    ? `
      top: 10px;
      right: 10px;
    `
    : `
      top: 10px;
      right: 10px;
    `
  }
  z-index: 2;
`;

export const ProfileHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  padding: 20px;
  padding-top: 40px;
  text-align: center;
  background-color: ${({ theme }) => theme?.card_color || 'initial'};
  
  ${({ imageStyle }) => imageStyle === 'Hero' && `
    height: 60vh;
    justify-content: flex-end;
    padding-bottom: 7px;
    position: relative;
    overflow: hidden;
    margin-top: 0;
    
    h2, p, ${ScrollableContainer} {
      position: relative;
      z-index: 1;
    }
  `}

  h2 {
    margin-top: 10px;
    font-size: 24px;
    color: ${({ theme }) => theme?.card_text_color || 'white'};
  }

  p {
    font-size: 16px;
    color: ${({ theme }) => theme?.card_text_color || 'white'};
  }
`;

export const HeroAvatar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: top;
  background-image: url(${props => props.src});
  background-size: cover;
  width: 100%;
  height: 100%;
  font-size: 32px;
  max-width: 750px;
  margin: auto;
  
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 50%;
    background: linear-gradient(to top, ${props => props.backgroundColor || 'transparent'} 0%, transparent 65%);
  }
`;

export const StyledShopCard = styled(Card)`
  &.ant-card {
    width: 100%; // Changed from 230px to 100%
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    background-color: ${props =>
    props.theme?.card_style?.includes('outline')
      ? 'transparent'
      : props.theme?.card_color || '#ffffff'};
    border: ${props =>
    props.theme?.card_style?.includes('outline')
      ? `2px solid ${props.theme?.card_color || '#f0f0f0'}`
      : `1px solid ${props.theme?.card_color || '#f0f0f0'}`};
    color: ${props => props.theme?.card_text_color};
  }

  .ant-card-cover img {
    width: 100%;
    height: auto; // Ensure the image scales properly
    object-fit: cover;
  }
`;

export const ShopHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 20px;
  width: 100%;
`;

export const GridItem = styled.div`
  width: 100%;
`;

export const ViewToggle = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  color: ${props => props.theme?.card_text_color || '#000'};
  opacity: ${props => props.active ? 1 : 0.5};
  
  &:hover {
    opacity: 1;
  }
`;